import React from 'react';
import style from './adBanner.less';
import * as analytics from '../../lib/analytics';
import MediaQuery from 'react-responsive';
import {
  blue300,
  Container,
  Row,
  Col,
  Icon,
  BodyText,
  Button,
  Link,
} from '@paypalcorp/pp-react';

const AdBanner = ({ fptiInfo, i18n }) => {
  return (
    <div className={style.banner} style={{ backgroundColor: blue300 }}>
      <Container>
        <Row align='center'>
          <Col form='auto' className={style.verticalMiddle}>
            <MediaQuery minWidth={511}>
              <Icon size='xl' name={i18n('label.banner-icon')} />
            </MediaQuery>
            <MediaQuery maxWidth={510}>
              <Icon size='xl2' name={i18n('label.banner-icon')} />
            </MediaQuery>
          </Col>
          <div className={style.bannerTitle}>
            <BodyText>{i18n('label.banner-title')}</BodyText>
          </div>
          <Col form='auto' className={style.verticalMiddle}>
            <Link
              onClick={() => {
                if (fptiInfo) {
                  analytics.trackLinkWithData(
                    'BannerCTA',
                    fptiInfo.pgrp,
                    fptiInfo.page,
                    {
                      link: i18n('label.banner-link'),
                    },
                    'link'
                  );
                }
              }}
              target='_blank'
              href={i18n('label.banner-link')}
            >
              <Button secondary>{i18n('label.banner-button')}</Button>
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AdBanner;
